import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../admin/AuthContext';
import { getToken } from '../admin/api';
import { useCustomer } from '../contexts/CustomerContext';
import { enablePush, refreshPush, pushConfigured } from '../lib/notifications';

export default function NotificationOptIn() {
  const { user } = useAuth();
  const { customer, token } = useCustomer();
  const { pathname } = useLocation();
  const role = pathname.startsWith('/admin') ? 'admin' : 'customer';
  const authToken = role === 'admin' ? (user && getToken()) : (customer && token);
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let alive = true;
    setEnabled(false);
    if (!authToken || !pushConfigured) return;
    const refresh = () => refreshPush({ role, token: authToken }).then(ok => { if (alive) setEnabled(ok); }).catch(() => {});
    refresh();
    window.addEventListener('focus', refresh);
    const timer = setInterval(refresh, 12 * 60 * 60 * 1000);
    return () => { alive = false; clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [role, authToken]);
  if (!pushConfigured || !authToken || enabled) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs rounded-lg bg-white p-3 shadow-lg border" role="region" aria-label="Booking notifications">
    <button disabled={busy} className="text-sm font-semibold text-blue-700" onClick={async () => {
      setBusy(true); setError('');
      try { await enablePush({ role, token: authToken }); setEnabled(true); }
      catch (e) { setError(e.response?.data?.detail || e.message); }
      finally { setBusy(false); }
    }}>{busy ? 'Enabling…' : 'Enable booking notifications'}</button>
    {error && <p role="alert" className="mt-2 text-sm text-red-700">{error}</p>}
  </div>;
}
